import AgentNotification from './agent_notification';

export default AgentNotification;
